import React from 'react';
import Summary from './Summary';
import Graphs from './Graphs';

export default function BusinessDashboard() {

  return (
    <div>
    <Summary />
    <Graphs />
  </div>
  )
}